var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6867 12.6816C10.57 12.6699 10.43 12.6699 10.3017 12.6816C7.52501 12.5883 5.32001 10.3133 5.32001 7.51325C5.32001 4.65492 7.63001 2.33325 10.5 2.33325C13.3583 2.33325 15.68 4.65492 15.68 7.51325C15.6683 10.3133 13.4633 12.5883 10.6867 12.6816Z",
    stroke: "#DC1F5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.145 4.66675C21.4083 4.66675 23.2283 6.49841 23.2283 8.75008C23.2283 10.9551 21.4783 12.7517 19.2967 12.8334C19.2033 12.8217 19.0983 12.8217 18.9933 12.8334",
    stroke: "#DC1F5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85334 16.9867C2.03001 18.8767 2.03001 21.9567 4.85334 23.8351C8.06167 25.9817 13.3233 25.9817 16.5317 23.8351C19.355 21.9451 19.355 18.8651 16.5317 16.9867C13.335 14.8517 8.07334 14.8517 4.85334 16.9867Z",
    stroke: "#DC1F5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3967 23.3333C22.2367 23.1583 23.03 22.8199 23.6833 22.3183C25.5033 20.9533 25.5033 18.7016 23.6833 17.3366C23.0417 16.8466 22.26 16.5199 21.4317 16.3333",
    stroke: "#DC1F5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.82a780d0bf075c46bc67f05ba744bde2.svg";
export { ForwardRef as ReactComponent };